import { render } from "./RecurringExpensesPage.vue?vue&type=template&id=02e96b13&scoped=true&ts=true"
import script from "./RecurringExpensesPage.vue?vue&type=script&lang=ts"
export * from "./RecurringExpensesPage.vue?vue&type=script&lang=ts"

import "./RecurringExpensesPage.vue?vue&type=style&index=0&id=02e96b13&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02e96b13"]])

export default __exports__